import { render, staticRenderFns } from "./vueWxlogin.vue?vue&type=template&id=9d9afb46"
import script from "./vueWxlogin.vue?vue&type=script&lang=js"
export * from "./vueWxlogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports